// extracted by mini-css-extract-plugin
module.exports = {"dateField":"DatePicker_dateField__3sozq","title":"DatePicker_title__tNjX6","date":"DatePicker_date__1vIWs","dash":"DatePicker_dash__1wWg5","calendar":"DatePicker_calendar__1Qor4"};